document.addEventListener('DOMContentLoaded', function() {
  let originalTitle = document.title;

  // Detect template based on URL path
  let path = window.location.pathname;

  // Determine page type
  let templateType = '';
  if (path.includes('/products/')) {
    templateType = 'product';
  } else if (path.includes('/cart')) {
    templateType = 'cart';
  } else if (path.includes('/collections/')) {
    templateType = 'collection';
  } else {
    templateType = 'other';
  }

  console.log("Tab notification detected template:", templateType, "from path:", path);

  // Choose notification text
  let notificationTitle;
  if (templateType === 'product') {
    notificationTitle = "🔥 Hurry, these are selling fast!";
  } else if (templateType === 'cart') {
    notificationTitle = "🔥 Hurry, don't lose your cart!";
  } else if (templateType === 'collection') {
    notificationTitle = "🔥 Hurry, stock is selling fast!";
  } else {
    notificationTitle = "🔥 Last chance for Black Friday Sale";
  }

  let titleInterval;
  let hasFlashed = false;

  function startTitleFlash() {
    hasFlashed = true;
    let showNotification = true;

    titleInterval = setInterval(function() {
      document.title = showNotification ? notificationTitle : originalTitle;
      showNotification = !showNotification;
    }, 750);
  }

  function stopTitleFlash() {
    clearInterval(titleInterval);
    document.title = originalTitle;
  }

  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      startTitleFlash();
    } else {
      stopTitleFlash();

      if (hasFlashed) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'tab_return_from_flash',
          template_type: templateType
        });
      }
    }
  });
});
